import React from 'react';
import useTimer from 'hooks/useTimer';

/**
 * @component Timer
 * @description
 * Componente visual que muestra un temporizador en formato MM:SS.
 * Utiliza el hook `useTimer` para obtener el tiempo restante desde Redux.
 * 
 * Este componente es utilizado en la certificación para mostrar el tiempo restante de cada sección.
 * 
 * @returns {JSX.Element} Componente de temporizador renderizado.
 */
const Timer = () => {
    const { time } = useTimer();

    /**
     * @function formatTime
     * @description
     * Formatea el tiempo recibido (en segundos) al formato MM:SS.
     * 
     * @param {number} time - Tiempo en segundos.
     * @returns {string} Tiempo formateado como "MM:SS".
     */
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    return (
        <div style={timerStyles}>
            <h1 style={timerText}>{formatTime(time)}</h1>
        </div>
    );
};

export default Timer;

/**
 * @constant timerStyles
 * @description
 * Estilos del contenedor del temporizador.
 */
const timerStyles = {
    backgroundColor: '#f1f1f1',
    padding: '10px 20px',
    borderRadius: '10px',
    fontSize: '4em',
    color: '#333',
    zIndex: 1000,
};

/**
 * @constant timerText
 * @description
 * Estilos del texto del temporizador.
 */
const timerText = {
    fontSize: '4rem',
    color: '#333',
    textAlign: 'center'
};